import { virtel_schema_init } from '../ter/ter-virtel-definition-lib';
import { responsive_utils } from '../utils/responsive-utils';
import ajax from './ajax-adapter';

// INIT

let initialized = false;

export const init = () => {
  if (initialized === false) {
    // prevent init to fire twice // ready for React 18
    initialized = true;
    console.log('init() ...');
    // INIT RESPONSIVE
    responsive_utils.init();
    // INIT AJAX HEADERS
    ajax.init();
    // INIT VIRTEL SCHEMA LIB
    virtel_schema_init();
    //
    console.log('init() completed');
    return Promise.resolve(true);
  } else {
    return Promise.reject('init() can not be fired twice');
  }
};

// React 18 useEffect behavior - while Strict Mode <React.StrictMode> is active, all components mount and unmount before being remounted again. - The useEffect hook, which should only be called on the first mount, is called two times.
